import { useEffect, useState } from "react"

import { DebugDialog } from "./DebugDialog"

declare global {
  interface Window {
    /** Opens the debug dialog (UI-SL2W-014). DevTools console only. */
    sl2Debug?: () => void
  }
}

type DebugDialogHostProps = {
  version: string
  buildId: string
}

/**
 * Owns the debug dialog's open state and its only entry point:
 * `window.sl2Debug()` typed in the DevTools console (LOCKER-491).
 *
 * It replaces a root `onClick` that opened the dialog on any 10-click burst,
 * which operators triggered by accident while clicking fast. In embedded mode
 * the app runs in an iframe, so the call must run in the iframe's console
 * context — `window` here is the iframe's window.
 */
export const DebugDialogHost: React.FC<DebugDialogHostProps> = ({
  version,
  buildId,
}) => {
  const [open, setOpen] = useState(false)

  useEffect(() => {
    const openDialog = () => setOpen(true)
    window.sl2Debug = openDialog
    return () => {
      if (window.sl2Debug === openDialog) delete window.sl2Debug
    }
  }, [])

  if (!open) return null
  return (
    <DebugDialog
      onClose={() => setOpen(false)}
      version={version}
      buildId={buildId}
    />
  )
}
